import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from "../../../context/AuthContext";
import styled from 'styled-components';
const MessageRow = styled.tr`
  text-align: center;
`;

const MessageTd = styled.td`
  padding: 20px;
  font-style: italic;
`;
const MainContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  font-family: 'Arial', sans-serif;
`;

const InnerContainer = styled.div`
  width: calc(100% - 50px);
`;

const FormBox = styled.div`
  background-color: #ffffff;
  padding: 20px;
  border-radius: 10px;
  width: 100%; 
  margin-bottom: 20px; /* 테이블과 간격 조정 */
`;

const Title = styled.h2`
  text-align: left;
  color: #333;
  margin-bottom: 20px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Select = styled.select`
  width: 100%;
  padding: 8px; /* 패딩 줄임 */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px; /* 글꼴 크기 줄임 */
`;

const Input = styled.input`
  width: calc(100% - 20px) ;
  padding: 8px; /* 패딩 줄임 */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px; /* 글꼴 크기 줄임 */
`;

const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px; /* 그룹 간격 추가 */
`;

const CheckboxLabel = styled.label`
  margin-left: 8px;
  font-weight: bold;
`;

const Button = styled.button`
  width: 100%;
  padding: 15px;
  margin-top: 10px; /* 버튼 간 간격 조정 */
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px; /* 글꼴 크기 줄임 */
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #45a049;
  }
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: -10px;
  margin-bottom: 10px;
`;

const Table = styled.table`
  width: 100%; /* 너비 100%로 조정 */
  border-collapse: collapse;
  margin-top: 10px;
`;

const TableHeader = styled.th`
  border: 1px solid #ddd;
  padding: 8px; /* 패딩을 줄여서 컴팩트하게 만듦 */
  background-color: #f2f2f2;
  text-align: center;
  font-size: 12px; /* 글꼴 크기를 줄임 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px; /* 패딩을 줄여서 컴팩트하게 만듦 */
  text-align: center;
  font-size: 12px; /* 글꼴 크기를 줄임 */
  overflow: hidden;
  text-overflow: ellipsis;
`;
const TableButtonCell = styled.td`
  border: 1px solid #ddd;
  text-align: center;
  font-size: 14px; /* 글꼴 크기를 줄임 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding:10px;
`;

const StatusButton = styled.button`
  width: 100%;
  padding: 25px 10px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px; /* 글꼴 크기 줄임 */
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #45a049;
  }
`;

const ToggleButton = styled.button`
  padding: 6px 10px; /* 패딩을 줄임 */
  margin: 3px 5px;
  background-color: ${props => props.active ? '#3498db' : '#f44336'};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px; /* 글꼴 크기를 줄임 */
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${props => props.active ? '#45a049' : '#d32f2f'};
  }
`;

const DaysContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 3px; /* 버튼 간격 줄임 */
`;

const DayItem = styled.div`
  display: inline-block;
`;

const UserOptions = () => {
  const { isLoggedIn, user } = useAuth();
  const [options, setOptions] = useState([]);
  const [movies, setMovies] = useState([]);
  const [minPrice, setMinPrice] = useState(0); // 최소 가격 상태 추가
  const [maxPrice, setMaxPrice] = useState(0); // 최소 가격 상태 추가
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    theater: "",
    movie_title: "",
    capacity: "",
    min_price: "",
    min_people: "",
    max_people: "",
    booking_start_time: "",
    booking_end_time: "",
    watching_start_time: "",
    watching_end_time: "",
    available_days: [],
    booking_days: [],
    status: "active" // 기본값을 "active"로 설정
  });


  const fetchOptions = async () => {
    try {
      const response = await fetch(`/agent_options/getOptions`, {
        credentials: 'include',
      });
      const data = await response.json();
      setOptions(data);
    } catch (error) {
      console.error("옵션을 가져오는 중 오류 발생", error);
    }
  };

  const fetchMovies = async () => {
    try {
      const response = await fetch('/movieschedules/movies');
      if (!response.ok) throw new Error('영화 데이터를 불러오는 데 실패했습니다.');
      const data = await response.json();
      setMovies(data);
    } catch (error) {
      console.error('영화 데이터 가져오기 오류:', error);
    }
  };

  const fetchMinPrice = async () => {
    try {
      const response = await fetch('/agent_options/getPriceOptions', {
        credentials: 'include',
      });
  
      if (!response.ok) {
        throw new Error('최소 가격 데이터를 불러오는 데 실패했습니다.');
      }
  
      const data = await response.json();
  
      // 최소 및 최대 가격이 있는지 확인하고 상태 업데이트
      if (data.min_value !== undefined) {
        setMinPrice(data.min_value);
      } else {
        console.warn('min_price 값이 응답에 없습니다.');
      }
  
      if (data.max_value !== undefined) {
        setMaxPrice(data.max_value);
      } else {
        console.warn('max_price 값이 응답에 없습니다.');
      }
  
      //alert(`Min Price: ${data.min_value}, Max Price: ${data.max_value}`);
    } catch (error) {
      console.error('최소 가격 데이터 가져오기 오류:', error);
    }
  };

  useEffect(() => {
    fetchOptions();
    fetchMovies();
    fetchMinPrice(); // 최소 가격 데이터 가져오기
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    if (name === 'min_price') {
      newValue = value.replace(/\D/g, '');
    }

    setFormData({ ...formData, [name]: type === 'checkbox' ? (checked ? "active" : "inactive") : newValue });

    // 실시간 검증
    let newErrors = { ...errors };

    if (name === "min_price") {
      
      if (parseInt(value, 10) < minPrice) {
        newErrors[name] = `최소 가격은 ${minPrice}원 이상이어야 합니다.`;
      } else {
        delete newErrors[name];
      }
    } else if (["capacity", "min_people", "max_people"].includes(name)) {
      if (value < 1 || value > 99) {
        newErrors[name] = "1에서 99 사이의 값을 입력해주세요.";
      } else {
        delete newErrors[name];
      }
    }

    setErrors(newErrors);
  };

  const handleToggle = (field, value) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [field]: prevFormData[field].includes(value)
        ? prevFormData[field].filter(day => day !== value)
        : [...prevFormData[field], value]
    }));
  };

  const handleSelectAllDays = (field) => {
    const allDays = ['월', '화', '수', '목', '금', '토', '일'];
    setFormData(prevFormData => ({
      ...prevFormData,
      [field]: prevFormData[field].length === allDays.length ? [] : allDays
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // min_price가 비어있는지 확인
    if (!formData.min_price) {
      alert(`최소 가격을 입력해 주세요.`);
      setErrors({ ...errors, min_price: "최소 가격을 입력해 주세요." });
      return;
    }
  
    // 폼 제출 전 최종 검증
    if (parseInt(formData.min_price, 10) < minPrice) {
      alert(`최소 가격은 ${minPrice}원 이상이어야 합니다.`);
      setErrors({ ...errors, min_price: `최소 가격은 ${minPrice}원 이상이어야 합니다.` });
      return;
    }
      // 폼 제출 전 최종 검증
      if (parseInt(formData.max_price, 10) > maxPrice) {
        alert(`최대 가격은 ${max_price}원 이상이어야 합니다.`);
        setErrors({ ...errors, min_price: `최대 가격은 ${max_price}원 이상이어야 합니다.` });
        return;
      }
    try {
      const response = await fetch("/agent_options/addOption", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...formData, userId: user.id }),
        credentials: 'include',
      });
  
      if (response.ok) {
        fetchOptions();
        setFormData({
          theater: "",
          movie_title: "",
          capacity: "",
          min_price: "",
          min_people: "",
          max_people: "",
          booking_start_time: "",
          booking_end_time: "",
          watching_start_time: "",
          watching_end_time: "",
          available_days: [],
          booking_days: [],
          status: "active" // 기본값을 "active"로 설정
        });
        setErrors({});
      } else {
        console.error("옵션을 추가하는 중 오류 발생");
      }
    } catch (error) {
      console.error("옵션을 추가하는 중 오류 발생", error);
    }
  };

  const handleEdit = (option) => {
    setFormData(option);
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`/agent_options/deleteOption/${id}`, {
        method: "DELETE",
        credentials: 'include',
      });

      if (response.ok) {
        fetchOptions();
      } else {
        console.error("옵션을 삭제하는 중 오류 발생");
      }
    } catch (error) {
      console.error("옵션을 삭제하는 중 오류 발생", error);
    }
  };

  const handleStatusToggle = async (option) => {
    const updatedStatus = option.status === "active" ? "inactive" : "active";
    try {
      const response = await fetch(`/agent_options/updateStatus/${option.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status: updatedStatus }),
        credentials: 'include',
      });

      if (response.ok) {
        fetchOptions();
      } else {
        console.error("옵션 상태를 업데이트하는 중 오류 발생");
      }
    } catch (error) {
      console.error("옵션 상태를 업데이트하는 중 오류 발생", error);
    }
  };

  if (!isLoggedIn) {
    return <Navigate to="/Login" />;
  }

  return (
    <MainContainer>
      <InnerContainer>
        <FormBox>
          <Title>옵션 관리</Title>
            {options.length === 0 ? (
              <MessageRow>
                <MessageTd colSpan="14"> 현재 대행 옵션이 없습니다. 아래 옵션을 추가해주세요 </MessageTd>
              </MessageRow>
            ) : (
              options.map((option) => (
                <>
                <Table>
                <tbody>
            <tr>
              
              <TableHeader>최소 가격</TableHeader>
              <TableHeader>수용 인원</TableHeader>
              <TableHeader>최소 인원</TableHeader>
              <TableHeader>최대 인원</TableHeader>
              <TableHeader colSpan={2}>가능한 날</TableHeader>
              <TableHeader colSpan={2}>예약 가능한 날</TableHeader>
              <TableButtonCell rowSpan={2}>
                      <StatusButton
                        active={option.status === 'active'}
                        onClick={() => handleStatusToggle(option)}
                      >
                        {option.status === 'active' ? '비활성화' : '활성화'}
                      </StatusButton>
               </TableButtonCell>
            </tr>
          
                  {/* 첫 번째 데이터 로우: 기본 정보 및 날짜 정보 */}
                  <tr key={option.id}>
                    <TableCell>{option.min_price}</TableCell>
                    <TableCell>{option.capacity}</TableCell>
                    <TableCell>{option.min_people}</TableCell>
                    <TableCell >{option.max_people}</TableCell>
                    <TableCell colSpan={2}>
                      <DaysContainer>
                        {option.available_days.split(',').map((day, index) => (
                          <DayItem key={index}>{day}</DayItem>
                        ))}
                      </DaysContainer>
                    </TableCell>
                    <TableCell colSpan={2}>
                      <DaysContainer>
                        {option.booking_days.split(',').map((day, index) => (
                          <DayItem key={index}>{day}</DayItem>
                        ))}
                      </DaysContainer>
                    </TableCell>
                  </tr>

                  {/* 두 번째 데이터 로우: 시간 정보 */}
                  <tr>
                    <TableHeader colSpan={2}>극장</TableHeader>
                    <TableHeader colSpan={2} style={{width:'320px'}}>영화 제목</TableHeader>
                    <TableHeader style={{width:'125px'}}>대행 가능 시간</TableHeader>
                    <TableHeader style={{width:'125px'}}>대행 가능 종료 시간</TableHeader>
                    <TableHeader style={{width:'125px'}}>관람 시간 시작 시간</TableHeader>
                    <TableHeader style={{width:'125px'}}>관람 시간 종료 시간</TableHeader>
                    <TableButtonCell  style={{width:'90px'}} rowSpan={2}><StatusButton onClick={() => handleDelete(option.id)}>삭제</StatusButton></TableButtonCell>
                  </tr>
                  <tr>
                  <TableCell colSpan={2}>{option.theater || "제한없음"}</TableCell>
                  <TableCell colSpan={2}>{option.movie_title || "제한없음"}</TableCell>
                  <TableCell>{option.booking_start_time || "제한없음"}</TableCell>
                  <TableCell>{option.booking_end_time || "제한없음"}</TableCell>
                  <TableCell>{option.watching_start_time || "제한없음"}</TableCell>
                  <TableCell>{option.watching_end_time || "제한없음"}</TableCell>
                  </tr>
                  </tbody>
                  </Table>
                </>
              ))
            )}
          
        
          {/* 필수설정 */}
          <form onSubmit={handleSubmit}>
            <main style={{display:'flex',flexDirection:'row',padding:'0px 0px',borderStyle:'solid',borderWidth:'1px',borderColor:'silver',margin:'20px 0px',padding:'10px 20px 20px 20px'}}>
          <section style={{width:'100%', padding:'15px 15px 15px 0px'}}>
          <Label>일정선택</Label>
            <div style={{margin:'0px 0px 20px 0px',padding:'20px', borderRadius:'5px',  borderStyle:'solid',borderColor:'silver',borderWidth:'1px'}}>
            <Label>대행 가능한 날(대행자가 대행이 가능한 기간입니다)</Label>
              <div>
                <ToggleButton
                  type='button'
                  active={formData.available_days.length === 7}
                  onClick={() => handleSelectAllDays('available_days')}
                >
                  전체 선택
                </ToggleButton>
                {['월', '화', '수', '목', '금', '토', '일'].map((day, index) => (
                  <ToggleButton
                    type='button'
                    key={index}
                    active={formData.available_days.includes(day)}
                    onClick={() => handleToggle('available_days', day)}
                  >
                    {day}
                  </ToggleButton>
                ))}
              </div>

              <Label>예약 가능한 날(사용할 티켓의 예약이 가능한 날입니다)</Label>
              <div>
                <ToggleButton
                   type='button'
                  active={formData.booking_days.length === 7}
                  onClick={() => handleSelectAllDays('booking_days')}
                >
                  전체 선택
                </ToggleButton>
                {['월', '화', '수', '목', '금', '토', '일'].map((day, index) => (
                  <ToggleButton
                     type='button'
                    key={index}
                    active={formData.booking_days.includes(day)}
                    onClick={() => handleToggle('booking_days', day)}
                  >
                    {day}
                  </ToggleButton>
                ))}
              </div>
              
              <CheckboxGroup>
                <input type="checkbox" name="status" checked={formData.status === "active"} onChange={handleInputChange} />
                <CheckboxLabel>활성화</CheckboxLabel>
              </CheckboxGroup>
              </div>
              
              {/* 옵션설정 */}
            
       

            <Label>최소 가격</Label>
            <Input type="number" name="min_price" value={formData.min_price} onChange={handleInputChange} />
            {errors.min_price && <ErrorMessage>{errors.min_price}</ErrorMessage>}
            
            <Label>수용 인원</Label>
            <Input type="number" name="capacity" value={formData.capacity} min="1" max="99" onChange={handleInputChange} />
            {errors.capacity && <ErrorMessage>{errors.capacity}</ErrorMessage>}
            <Label>최소 인원</Label>
            <Input type="number" name="min_people" value={formData.min_people} min="1" max="99" onChange={handleInputChange} />
            {errors.min_people && <ErrorMessage>{errors.min_people}</ErrorMessage>}

            <Label>최대 인원</Label>
            <Input type="number" name="max_people" value={formData.max_people} min="1" max="99" onChange={handleInputChange} />
            {errors.max_people && <ErrorMessage>{errors.max_people}</ErrorMessage>}
            </section>  
            <section style={{width:'100%',padding:'15px'}}>
              
            <Label>극장</Label>
            <Select name="theater" value={formData.theater} onChange={handleInputChange}>
              <option value="">극장을 선택하세요</option>
              <option value="CGV">CGV</option>
              <option value="메가박스">메가박스</option>
              <option value="롯데시네마">롯데시네마</option>
            </Select>

            <Label>영화 제목</Label>
            <Select name="movie_title" value={formData.movie_title} onChange={handleInputChange}>
              <option value="">영화 제목을 선택하세요</option>
              {movies.map((movie, index) => (
                <option key={index} value={movie}>{movie}</option>
              ))}
            </Select>

            <Label>예약 시작 시간</Label>
            <Input type="time" name="booking_start_time" value={formData.booking_start_time} onChange={handleInputChange} />

            <Label>예약 종료 시간</Label>
            <Input type="time" name="booking_end_time" value={formData.booking_end_time} onChange={handleInputChange} />

            <Label>관람 시작 시간</Label>
            <Input type="time" name="watching_start_time" value={formData.watching_start_time} onChange={handleInputChange} />

            <Label>관람 종료 시간</Label>
            <Input type="time" name="watching_end_time" value={formData.watching_end_time} onChange={handleInputChange} />
            </section>
            </main>
            <Button type="submit">옵션 추가</Button>
          </form>
         
        </FormBox>
      </InnerContainer>
    </MainContainer>
  );
};

export default UserOptions;
